import { render, staticRenderFns } from "./AddEventModal.vue?vue&type=template&id=1ad2f99a&scoped=true&lang=pug"
import script from "./AddEventModal.vue?vue&type=script&lang=js"
export * from "./AddEventModal.vue?vue&type=script&lang=js"
import style0 from "./AddEventModal.vue?vue&type=style&index=0&id=1ad2f99a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad2f99a",
  null
  
)

export default component.exports